import { usePermissions } from '@/hooks/usePermissions';
import { AccessLevel } from '@/types/permissions';
import { Navigate, useLocation } from 'react-router-dom';

interface PermissionGuardProps {
  pageKey: string;
  minLevel?: AccessLevel;
  children: React.ReactNode;
}

export function PermissionGuard({ pageKey, minLevel = 'READ', children }: PermissionGuardProps) {
  const { level, loading } = usePermissions({ pageKey });
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-[200px] flex-col items-center justify-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-slate-200)] border-t-[var(--color-primary)]" />
        <div className="text-sm text-[var(--color-muted-foreground)]">Loading permissions...</div>
      </div>
    );
  }

  const lv = { NONE: 0, VIEWOWN: 1, READ: 2, READWRITE: 3, ADMIN: 4 };
  if (lv[level] < lv[minLevel]) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
